import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";
import VeriHeading from "../VeriHeading";
import { DownloadIcon } from "./Icons";

const DownloadBox = ({ title, filename, href, ...rest }) => {
  const re = /(?:\.([^.]+))?$/;
  const extension = re.exec(filename)[1];
  return (
    <a href={href}>
      <Box
        px="24px"
        py="16px"
        bg="#FFF"
        boxShadow="2"
        borderRadius={4}
        borderColor="border.input"
        borderWidth="1px"
        cursor="pointer"
        data-testid="download-box"
        {...rest}
      >
        <Flex justifyContent="space-between">
          <Flex>
            <VeriHeading
              textStyle="bodyXS"
              fontWeight="600"
              color="white"
              bg="icons.grey"
              borderRadius={4}
              px="4px"
              height="20px"
            >
              {(extension || "").toUpperCase()}
            </VeriHeading>
            <Text ml="16px">{title}</Text>
          </Flex>
          <Flex>
            <Flex>
              <Icon
                // p="8px"
                boxSize="20px"
                cursor="pointer"
                as={DownloadIcon}
                color="brand.main"
              />
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </a>
  );
};
export default DownloadBox;
